import { generateLogzTestAttributes } from '@logz-pkg/test-selectors';
import { get } from 'lodash';
import { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import { Flex } from '../../containers/Flex/Flex.component';
import { Group } from '../../containers/Group/Group.component';
import { Text } from '../../typography';
import { SpinnerContainer, SpinnerSvg } from './Spinner.styles';
import { ISpinnerProps } from './Spinner.types';

export const Spinner: FunctionComponent<ISpinnerProps> = ({
  size = 'l',
  subject,
  color,
  fullscreen = false,
  title = null,
  className = '',
  ...props
}) => {
  const theme = useTheme();

  const spinnerColor = color ? get(theme.colors, color) ?? color : theme.spinner.color;

  if (!fullscreen)
    return (
      <SpinnerContainer
        role={'progressbar'}
        size={size}
        {...generateLogzTestAttributes({ context: 'loading', subject })}
        {...props}
      >
        <SpinnerSvg color={spinnerColor} />
      </SpinnerContainer>
    );

  return (
    <Flex
      height="100%"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      subject={subject}
      className={className}
      context={'stretched-loader'}
    >
      <Group vertical alignItems={'center'} gap={5}>
        {title && <Text>{title}</Text>}
        <Spinner size={size} />
      </Group>
    </Flex>
  );
};

Spinner.displayName = 'Spinner';
